<script lang="ts">
    import MoreButton from "../../widgets/MoreButton.svelte"

    let { block }: { block: Block<"articleLink"> } = $props()
</script>

<MoreButton
    text={block.content.link_title}
    type="dark"
    page_ref={block.content.article_page[0]}
    size="big"
    align="top"
/>

<style lang="less"></style>
